<template>
  <!-- 全屏预览弹窗 -->
  <el-dialog
    title="图片预览"
    :visible="visible"
    width="500px"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    class=""
    center
    @close="handleClose"
  >
    <!-- 预览内容区 -->
    <div class="preview-container">
      <!-- 左侧切换按钮 -->
      <button
        class="nav-btn left-btn"
        @click="switchImage(-1)"
        v-if="imageList.length > 1"
      >
        <i class="el-icon-arrow-left"></i>
      </button>

      <!-- 中间预览图片 -->
      <img
        v-if="imageList[currentIndex]"
        :src="imageList[currentIndex]"
        class="preview-img"
        alt="全屏预览图"
        @error="handleImgError"
      >
      <div class="empty-tip" v-else>暂无图片可预览</div>

      <!-- 右侧切换按钮 -->
      <button
        class="nav-btn right-btn"
        @click="switchImage(1)"
        v-if="imageList.length > 1"
      >
        <i class="el-icon-arrow-right"></i>
      </button>

      <!-- 页码提示 -->
      <div class="preview-page" v-if="imageList.length > 0">
        {{ currentIndex + 1 }} / {{ imageList.length }}
      </div>
    </div>

    <!-- 底部关闭按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">关闭预览</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImageFullscreenPreview',
  // 组件接收的外部参数
  props: {
    // 控制组件显示/隐藏（必传）
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    // 图片列表（必传，格式：['url1', 'url2', ...]）
    imageList: {
      type: Array,
      required: true,
      default: () => []
    },
    // 初始预览的图片索引（可选，默认0）
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 当前预览的图片索引（内部维护，避免直接修改props）
      currentIndex: this.initialIndex
    }
  },
  // 监听props变化，同步索引
  watch: {
    initialIndex (newVal) {
      this.currentIndex = newVal
    },
    imageList (newVal) {
      // 若图片列表清空，重置索引
      if (newVal.length === 0) {
        this.currentIndex = 0
      } else if (this.currentIndex >= newVal.length) {
        // 若当前索引超出新列表长度，重置为最后一张
        this.currentIndex = newVal.length - 1
      }
    }
  },
  methods: {
    // 切换图片（step：-1=上一张，1=下一张）
    switchImage (step) {
      const newIndex = this.currentIndex + step
      const listLength = this.imageList.length

      // 边界处理：循环切换
      if (newIndex < 0) {
        this.currentIndex = listLength - 1
      } else if (newIndex >= listLength) {
        this.currentIndex = 0
      } else {
        this.currentIndex = newIndex
      }
    },
    // 图片加载失败处理
    handleImgError (e) {
      e.target.src = 'https://via.placeholder.com/200x100?text=图片加载失败' // 占位图
    },
    // 弹窗关闭时，通知父组件（可选，用于清理逻辑）
    handleClose () {
      this.$emit('close') // 向父组件触发close事件
    }
  }
}
</script>

<style scoped lang="less">
/* 全屏弹窗基础样式 */
.image-fullscreen-preview {
  ::v-deep .el-dialog {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    padding: 20px !important;
    box-sizing: border-box;
    border-radius: 0 !important;
  }

  ::v-deep .el-dialog__body {
    height: calc(100% - 100px) !important;
    padding: 0 !important;
    overflow: hidden;
  }

  ::v-deep .el-dialog__footer {
    text-align: center !important;
    padding: 15px 0 !important;
    border-top: 1px solid #eee;
  }
}

/* 预览内容区 */
.preview-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.02);
}

/* 预览图片 */
.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

/* 切换按钮 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 24px;
  border: none;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.nav-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.left-btn {
  left: 20px;
}

.right-btn {
  right: 20px;
}

/* 页码提示 */
.preview-page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  z-index: 10;
}

/* 空提示 */
.empty-tip {
  font-size: 16px;
  color: #999;
  padding: 20px;
}
</style>
